/* eslint-disable i18next/no-literal-string */

import {
  borderRadius,
  Box,
  Button,
  Icon,
  Image,
  Paper,
  Typography,
} from "@outschool/backpack";
import { faChevronLeft } from "@outschool/icons";
import React from "react";

import goatWizardImage from "./avatar-animals/goat-wizard.webp";
import { AvatarBuilderHeroLayout } from "./AvatarBuilderHeroLayout";
import { RemoveCreatureButton } from "./RemoveCreatureButton";

export interface AvatarBuilderGenerationDisabledProps {
  isMobile: boolean;
  onBack: () => void;
  isClearing: boolean;
  onClearCreature: () => Promise<void>;
}

export function AvatarBuilderGenerationDisabled({
  isMobile,
  onBack,
  isClearing,
  onClearCreature,
}: AvatarBuilderGenerationDisabledProps) {
  return (
    <AvatarBuilderHeroLayout>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <Button
          startIcon={<Icon icon={faChevronLeft} />}
          size="small"
          sx={{ width: "fit-content", marginBottom: "5px" }}
          onClick={onBack}
        >
          Back
        </Button>
        <Paper
          variant="elevation"
          sx={{
            borderRadius: borderRadius.medium,
            padding: { xs: "16px", md: "32px" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 4,
              alignItems: "center",
            }}
          >
            <Typography variant="h1">Create Avatar</Typography>
            <Image
              src={goatWizardImage}
              alt="Avatar Wizard"
              width={isMobile ? 300 : 500}
              height={isMobile ? 300 : 500}
              sx={{
                borderRadius: borderRadius.medium,
                objectFit: "contain",
              }}
            />
            <Typography
              variant="body1"
              sx={{ fontStyle: "italic", textAlign: "center" }}
            >
              Looks like the Avatar Wizard needs to recharge, please come back
              another time.
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                alignItems: "flex-start",
              }}
            >
              <RemoveCreatureButton
                isClearing={isClearing}
                onClear={onClearCreature}
              />
              <Typography variant="caption" color="textSecondary">
                Removing your creature will reset your profile picture to the
                default avatar
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>
    </AvatarBuilderHeroLayout>
  );
}
